"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPreviousOtherOrganTransplantation = createPreviousOtherOrganTransplantation;
const messages_1 = require("./messages");
const utils_1 = require("../../../events/utils");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const previousOtherOrganTransplantation_1 = require("../../../forms/ktx/basic-registration-data/clinical-data/pre-immunisation/previousOtherOrganTransplantation");
const valueMessages = {
    [previousOtherOrganTransplantation_1.PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_KIDNEY]: messages_1.messages.prevTransKidney,
    [previousOtherOrganTransplantation_1.PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_LIVER]: messages_1.messages.prevTransLiver,
    [previousOtherOrganTransplantation_1.PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_HEART]: messages_1.messages.prevTransHeart,
    [previousOtherOrganTransplantation_1.PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_LUNG]: messages_1.messages.prevTransLung,
    [previousOtherOrganTransplantation_1.PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_PANCREAS]: messages_1.messages.prevTransPancreas,
    [previousOtherOrganTransplantation_1.PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_BONE_MARROW]: messages_1.messages.prevTransBoneMarrow,
    [previousOtherOrganTransplantation_1.PreviousOtherOrganTransplantationType.PREVIOUS_TRANSPLANTATION_OTHER]: messages_1.messages.prevTransOther
};
function createPreviousOtherOrganTransplantation(intl, { events }) {
    const { formatMessageMap } = intl;
    const relevantEvents = (0, utils_1.findEventsByQuery)(events, queries_1.preImmunisationQueries.previousOtherOrganTransplantation);
    const values = relevantEvents
        .filter(event => event.value in valueMessages)
        .sort(shared_1.compareByTimestamp)
        .map(event => event.value)
        .filter(value => value in valueMessages)
        .map(value => formatMessageMap(valueMessages, value));
    const uniqueValues = [...new Set(values)];
    return uniqueValues.length === 0 ? "-" : uniqueValues.join(", ");
}
